import { BaseDocumentId, customNanoId } from "../base-document-id";
import type {
	DocumentGenerationVersion,
	DocumentHistoryVersion,
	DocumentUniqueId,
} from "../types";

export class CardDocumentId extends BaseDocumentId {
	constructor(
		id?: DocumentUniqueId,
		generationVersion?: DocumentGenerationVersion,
		historyVersion?: DocumentHistoryVersion,
	) {
		super("card", id ?? customNanoId(), generationVersion, historyVersion);
	}

	atGenerationVersion(generationVersion: DocumentGenerationVersion) {
		return new CardDocumentId(this.id, generationVersion, this.historyVersion);
	}

	atHistoryVersion(historyVersion: DocumentHistoryVersion) {
		return new CardDocumentId(this.id, this.generationVersion, historyVersion);
	}
}
